import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {NotificationSettingsComponent} from './components/notification-settings/notification-settings.component';
import {PaymentDetailsComponent} from './components/payment-details/payment-details.component';
import {ReferralsComponent} from './components/referrals/referrals.component';
import {WalletComponent} from './components/wallet/wallet.component';
import {BetterDealsAlertComponent} from './components/better-deals-alert/better-deals-alert.component';
import {AccountRoutingModule} from './account-routing.module';
import {AccountComponent} from './account.component';
import {CreditCardDirectivesModule} from 'angular-cc-library';

@NgModule({
  declarations: [
    ChangePasswordComponent,
    NotificationSettingsComponent,
    PaymentDetailsComponent,
    ReferralsComponent,
    WalletComponent,
    BetterDealsAlertComponent,
    AccountComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    AccountRoutingModule,
    SharedModule,
    CreditCardDirectivesModule
  ]
})
export class AccountModule {
}
